export const billingEmailAddress = 'billing@pavecommute.app';
export const supportEmailAddress = 'support@pavecommute.app';
export const helpCenterUrl = 'https://help.pavecommute.app';
export const bookADemoUrlUS = 'https://calendly.com/corey-tucker/15min';
export const bookADemoUrlEU = 'https://calendly.com/albert-_4qa/30min';
